import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {

	const { token } = useSelector(state => state.auth)
	const location = useLocation();

	// return token ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet/>

	return <Outlet context={{ queryString: location.search }} />

}

export default PublicRoute